import { createTheme } from '@mui/material/styles';

import components from './components';
import { breakpointValues } from './constants';
import createMixins from './mixins';
import { lightPalette } from './palette-light';
import { type ITypographyPalette, createTypography } from './typography';

export function createAppTheme(palette: Record<string, unknown>) {
  const themeWithoutMixins = createTheme({
    breakpoints: breakpointValues,
    typography: createTypography(palette as ITypographyPalette),
    palette,
    components,
  });

  return createTheme({
    ...themeWithoutMixins,
    mixins: createMixins(
      themeWithoutMixins.breakpoints,
      themeWithoutMixins.spacing,
      themeWithoutMixins.palette,
    ),
  });
}

export default createAppTheme(lightPalette);
